import React from "react";
import styled from "styled-components";

import BackgroundImage from "../../../assets/intro/phone-bg.png";
import PopupBlur from "../../../assets/intro/popup-blur.png";
import AlertIcon from "../../../assets/intro/icon_alert.png";

import typography from "../../../theme/typography";

const Page = styled.div`
  position: relative;
  background-color: #f3ede5;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Background = styled.img`
  position: absolute;
  top: 128px;
`;

const Time = styled.div`
  position: relative;
  text-align: center;
  margin-top: 111px;
  height: 109px;
  p:first-child {
    font-size: 70px;
    margin-bottom: 1px;
  }
  p:last-child {
    font-size: 20px;
    font-weight: 300;
  }
`;

const Notification = styled.div`
  position: relative;
  margin-top: 63px;
  width: 320px;

  & > p {
    font-size: 20px;
    font-weight: 300;
    margin-bottom: 13px;
    height: 24px;
    padding: 0 10px;
  }
`;

const Message = styled.div`
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  padding: 2px 8px;
  width: 320px;
  height: 95px;
  box-sizing: border-box;
`;

const Blur = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const MessageHeader = styled.div`
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  margin-bottom: 1px;
  div {
    ${typography.popupText};
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;

const MessageContent = styled.p`
  position: relative;
  z-index: 100;
  ${typography.popupText};
  text-align: left;
`;

const ClickMessage = styled.p`
  position: absolute;
  z-index: 100;
  bottom: 80px;
  text-align: center;
  color: #22222290;
  letter-spacing: 1.2px;
  animation: scale 1s infinite alternate linear;
  @keyframes scale {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.1);
    }
  }
`;

const IntroPage2 = ({ setCurrentPage }) => {
  const goNextPage = () => setCurrentPage(3);

  return (
    <Page onClick={goNextPage}>
      <Background
        src={BackgroundImage}
        alt="Reduce Reuse Recycle이 적힌 휴대폰 배경"
      />
      <Time>
        <p>11:48</p>
        <p>2025년 **월 **일</p>
      </Time>
      <Notification>
        <p>알림센터</p>
        <Message>
          <Blur src={PopupBlur} alt="" />
          <MessageHeader>
            <img src={AlertIcon} alt="경고" />
            <div>
              <span>긴급 안내 문자</span>
              <span>2025년 **월 **일</span>
            </div>
          </MessageHeader>
          <MessageContent>
            [서울특별시청] 국민 여러분께 알립니다. 현재 수도권 매립지 포화로
            인해...
          </MessageContent>
        </Message>
      </Notification>

      <ClickMessage>(터치)</ClickMessage>
    </Page>
  );
};

export default IntroPage2;
